/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * Model SVG Icons
 */
import { ReactComponent as Alert } from "assets/images/icons/models/alert-model.svg";
import { ReactComponent as Bylaw } from "assets/images/icons/models/bylaw-model.svg";
import { ReactComponent as Committee } from "assets/images/icons/models/committee-model.svg";
import { ReactComponent as Custom } from "assets/images/icons/models/custom-model.svg";
import { ReactComponent as DevApplication } from "assets/images/icons/models/dev-app-model.svg";
import { ReactComponent as DevPermitArea } from "assets/images/icons/models/dpa-model.svg";
import { ReactComponent as Event } from "assets/images/icons/models/event-model.svg";
import { ReactComponent as Licence } from "assets/images/icons/models/licence-model.svg";
import { ReactComponent as Meeting } from "assets/images/icons/models/meeting-model.svg";
import { ReactComponent as Neighbourhood } from "assets/images/icons/models/neighbourhood-model.svg";
import { ReactComponent as News } from "assets/images/icons/models/news-model.svg";
import { ReactComponent as Advisory } from "assets/images/icons/models/advisory-model.svg";
import { ReactComponent as Permit } from "assets/images/icons/models/permit-model.svg";
import { ReactComponent as Report } from "assets/images/icons/models/report-model.svg";
import { ReactComponent as ReportSection } from "assets/images/icons/models/report-section-model.svg";
import { ReactComponent as Story } from "assets/images/icons/models/story-model.svg";
import { ReactComponent as Services } from "assets/images/icons/models/services-model.svg";
import { ReactComponent as Page } from "assets/images/icons/models/page-model.svg";
import { ReactComponent as Integration } from "assets/images/icons/models/integration-model.svg";

// import { ReactComponent as Warning } from 'assets/images/icons/models/triangle-exclamation-regular.svg'
// import { ReactComponent as Copy, ReactComponent as Duplicate } from 'assets/images/icons/common/copy-regular.svg'

const models = {
    Alert,
    Bylaw,
    Committee,
    Custom,
    Integration,
    DevApplication,
    DevPermitArea,
    Event,
    Licence,
    Meeting,
    Neighbourhood,
    News,
    Advisory,
    Page,
    Permit,
    Report,
    ReportSection,
    Services,
    Story,
};

export { models };
